import apiResponse from '../api/ApiResponse';
import { SurveyResponseStore } from '@stores';
import { SectionView } from '@views';
import actionResponse, { ActionResponse } from './ActionResponse';
import { useMutation } from '@tanstack/react-query';

export class SaveSurveyResponsesAction {
  constructor(private readonly store: SurveyResponseStore = new SurveyResponseStore()) {}

  public async Execute(section: SectionView, groupId: number, surveyId: number): Promise<ActionResponse> {
    try {
      await apiResponse.handleApiResponse(() => this.store.Write(section, groupId, surveyId));
      return actionResponse.Success('saved responses');
    } catch (err) {
      return actionResponse.HandleError(err);
    }
  }
}

export const useSaveSurveyResponsesAction = () =>
  useMutation({
    mutationFn: async (argument: { section: SectionView; groupId: number; surveyId: number }) => {
      const action = new SaveSurveyResponsesAction();
      return action.Execute(argument.section, argument.groupId, argument.surveyId);
    },
  });
